<div class="pt-2 pb-2 px-3 h-full flex flex-col gap-3">
    <div class="text-md pt-4">In order for you to quickly add items to your shopping list using you voice, please grant us below permissions that will appear next. Your privacy is our priority. See below</div>
    <div class="flex flex-col gap-3 items-center p-5 py-6 bg-green-50 rounded-lg">
        <div [style]="{'border-color': '#4D7935'}" class="rounded-full w-12 h-12 flex justify-center items-center border-2 border-green-500">
            <i class="pi pi-microphone text-2xl text-green-500"></i>
        </div>
        <div class="text-center text-sm">We need <b>Microphone</b> access to listen to you when you want to quickly add items to shopping list by just talking. We will never record or listen to you in the background.</div>
    </div>
    <div class="flex flex-col gap-3 items-center py-6 p-5 bg-green-50 rounded-lg">
        <div [style]="{'border-color': '#4D7935'}" class="rounded-full  w-12 h-12 flex justify-center items-center border-2">
            <i class="pi pi-language text-2xl text-green-500"></i>
        </div>
        <div class="text-center text-sm">We need <b>Speech Recognition</b> access to convert your voice to text. You will see the text as you speak. Apple may use this data to improve their speech recognition services. We do not store or send your voice data to any other service.</div>
    </div>

    @if (!(voiceRecognitionPermissionsStatus?.microphonePermissionStatus?.granted && voiceRecognitionPermissionsStatus?.speechRecognizerPermissionStatus?.granted)  &&  (voiceRecognitionPermissionsStatus?.microphonePermissionStatus?.canAskAgain && voiceRecognitionPermissionsStatus?.speechRecognizerPermissionStatus?.canAskAgain) ) {
        <div class="flex flex-col items-center mt-4">
            <p-button
                (click)="continueWithPermissions()"
                [label]="'Continue'"
                [style]="{background: '#4D7935'}"
                class="[&_button]:border-0 [&_button]:text-white" />
    
            <!-- <p-button 
                [label]="'Deny'" 
                [text]="true" 
                (click)="closeDialog()"  
                class="[&_button]:w-full mt-2"/> -->
        </div>
    } @else if(!voiceRecognitionPermissionsStatus?.microphonePermissionStatus?.canAskAgain || !voiceRecognitionPermissionsStatus?.speechRecognizerPermissionStatus?.canAskAgain) {
        <div class="flex flex-col items-center gap-4">
            <!-- <p-message severity="error">Permissions were turned off. Please go to settings and turn on Microphone and Speech Recognition Permissions</p-message> -->
            <p-button
                (click)="goToSettings()"
                [label]="'Open Settings'"
                [style]="{background: '#4D7935'}"
                class="[&_button]:border-0 [&_button]:text-white" />
            
        </div>
    }
    
    

</div>


